import { render, staticRenderFns } from "./BuilderSelectedFieldItem.vue?vue&type=template&id=4cb9b5e6"
import script from "./BuilderSelectedFieldItem.vue?vue&type=script&lang=js"
export * from "./BuilderSelectedFieldItem.vue?vue&type=script&lang=js"
import style0 from "./BuilderSelectedFieldItem.vue?vue&type=style&index=0&id=4cb9b5e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports